import request from './request'

//Para cada módulo crear un archivo con las requests necesarias, para exportarlas y llamarlas desde el componente correspondiente

export function getAllConcursos(){
    return request({
        url:'/concursos/all',
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getDetallesConcurso(idConcurso){
    return request({
        url:'/concursos/id/' + idConcurso,
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getInformeConcurso(idConcurso){
    return request({
        url:'/concursos/infocompleta/' + idConcurso,
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getExpedientesConcurso(idConcurso){
    return request({
        url:'/expedientes/concurso/' + idConcurso,
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getDetallesExpediente(idExpediente){
    return request({
        url:'/expedientes/id/' + idExpediente,
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getCriteriosConcurso(){
    return request({
        url:'/utilidades/criteriosevaluacion/all',
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function añadirCriterioAConcurso(criterio){
    return request({
        url:'/concursos/criterioevaluacion',
        method:'POST',
        data: criterio,
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function crearExpediente(expediente){
    return request({
        url:'/expedientes',
        method:'POST',
        data: expediente,
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getModelosCalculo(){
    return request({
        url:'/utilidades/calculosconcursos/all',
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function calcularBajas(id){
    return request({
        url:'/concursos/detectarbajas/' + id,
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function calcularPuntos(id){
    return request({
        url:'/concursos/calcularpuntos/' + id,
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function detectarEmpates(id){
    return request({
        url:'/concursos/detectarempates/' + id,
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function simularResolucion(id){
    return request({
        url:'/concursos/detectarempatessignificativos/' + id,
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function resolverConcurso(id){
    return request({
        url:'/concursos/resolverconcurso/' + id,
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function cerrarConcurso(id, contraseña){
    return request({
        url:'/concursos/cerrarconcurso/' + id,
        method:'PUT',
        data: {
            user: window.localStorage.getItem("email"),
            password: contraseña 
        },
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function crearConcurso(concurso){
    return request({
        url:'/concursos',
        method:'POST',
        data: concurso,
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function eliminarConcurso(id){
    return request({
        url:'/concursos/'+id,
        method:'DELETE',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function eliminarExpediente(idExpediente, nombre){
    return request({
        url:'/expedientes/' + idExpediente,
        method:'DELETE',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function actualizarExpediente(idExpediente, nombre){
    return request({
        url:'/expedientes/' + idExpediente,
        method:'PUT',
        data: {
            nombre: nombre
        },
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function actualizarConcurso(idConcurso, concurso){
    return request({
        url:'/concursos/' + idConcurso,
        method:'PUT',
        data: concurso,
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}